"use client";

import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import { CodeBlockNodeView } from "./components/CodeBlockNodeView";
import { EXTENSION_NAME } from "./constants";

export const CodeBlock = CodeBlockLowlight.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      caption: undefined,
      filename: undefined,
    };
  },
  addOptions() {
    return {
      ...this.parent?.(),
      onCopy: () => {},
    };
  },
}).configure({
  defaultLanguage: "plaintext",
  HTMLAttributes: {
    class: "block-code",
  },
  // @ts-expect-error
  onCopy: () => {
    console.log("Copy");
  },
});

export const CodeBlockNodeMapping = {
  [EXTENSION_NAME]: CodeBlockNodeView,
};
